'use client';

import { Button, Flex, Grid } from 'antd';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import React from 'react';

import styles from './notification-message-error.styles';

/**
 * Props para el componente NotificationMessageError.
 */
export type NotificationMessageErrorProps = {
  /**
   * Clase de ícono Bootstrap para mostrar (ej. 'bi-x-circle' o 'bi bi-x-circle').
   */
  icon?: string;
  /**
   * URL de imagen para mostrar en lugar del ícono.
   */
  imageSrc?: string;
  /**
   * Título del mensaje.
   */
  title?: string;
  /**
   * Texto descriptivo principal.
   */
  text?: string;
  /**
   * Callback para el botón primario.
   */
  primaryCallback?: () => void;
  /**
   * Callback para el botón secundario.
   */
  secondaryCallback?: () => void;
};

const NotificationMessageError = ({
  icon = 'bi-x-circle',
  imageSrc = '',
  title = 'Algo salió mal',
  text = 'No pudimos obtener la información de tu pedido en este momento. Intentá recargando la página o vuelve a intentarlo más tarde.',
  primaryCallback,
  secondaryCallback
}: Readonly<NotificationMessageErrorProps>) => {
  const resolveIconClass = (cls: string) => (cls.includes('bi') ? cls : `bi ${cls}`);

  const screens = Grid.useBreakpoint();
  const isDesktop = !!(screens.lg || screens.xl || screens.xxl);
  const isTabletOrUp = !!(screens.md || screens.lg || screens.xl || screens.xxl);
  const cardStyle: React.CSSProperties = isDesktop
    ? { ...styles.card, maxWidth: 'none' }
    : styles.card;
  const containerStyle: React.CSSProperties = isTabletOrUp
    ? { ...styles.container, alignItems: 'center', minHeight: '65vh' }
    : styles.container;

  return (
    <div style={containerStyle}>
      <Flex vertical style={cardStyle}>
        <div style={styles.header}>
          {(imageSrc || icon) && (
            <div style={styles.iconCircle}>
              {imageSrc ? (
                <img src={imageSrc} alt='notification' style={styles.image} />
              ) : (
                <i className={resolveIconClass(icon)}></i>
              )}
            </div>
          )}
          {title && <h2 style={styles.title}>{title}</h2>}
        </div>
        {text && <p style={styles.text}>{text}</p>}
        {(primaryCallback || secondaryCallback) && (
          <Flex gap='middle' style={styles.actions}>
            {secondaryCallback && (
              <Button onClick={secondaryCallback} style={styles.secondaryButton}>
                <i className='bi bi-arrow-left' style={{ color: 'inherit' }}></i>
                Volver
              </Button>
            )}
            {primaryCallback && (
              <Button type='primary' onClick={primaryCallback} style={styles.primaryButton}>
                <i className='bi bi-arrow-repeat' style={{ color: 'inherit' }}></i>
                Reintentar
              </Button>
            )}
          </Flex>
        )}
      </Flex>
    </div>
  );
};

export default NotificationMessageError;
